export const FETCH_PROCEDURE_LOOKUP_REQUEST = "FETCH_PROCEDURE_LOOKUP_REQUEST";
export const FETCH_PROCEDURE_LOOKUP_SUCCESS = "FETCH_PROCEDURE_LOOKUP_SUCCESS";
export const FETCH_PROCEDURE_LOOKUP_FAILURE = "FETCH_PROCEDURE_LOOKUP_FAILURE";
